// extracted by mini-css-extract-plugin
module.exports = {"player":"styles_player__syofr","watch":"styles_watch__RY2K6","playerBox":"styles_playerBox__f3glV","isOpenMobile":"styles_isOpenMobile__G2WXd","iframe":"styles_iframe__nWBYo"};